import { render, staticRenderFns } from "./PajakPbb.vue?vue&type=template&id=2d3dee08&scoped=true&"
import script from "./PajakPbb.vue?vue&type=script&lang=js&"
export * from "./PajakPbb.vue?vue&type=script&lang=js&"
import style0 from "./PajakPbb.vue?vue&type=style&index=0&id=2d3dee08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3dee08",
  null
  
)

export default component.exports